<template>
  <div>
    <section class="page d-flex align-content-start" style="flex-wrap: wrap">
      <Label v-for="item in list" :key="item.id" :orderItem="item" />
    </section>
  </div>
</template>

<script>
import Label from "@/components/driver/label.vue";
import { formatDate } from "@/plugins/i18n";

export default {
  components: {
    Label
  },
  data() {
    return {
      selectedDate: "",
      selectedArea: 0,
      deliveryDates: [],
    };
  },
  async created() {
    await this.initializeDeliveryDate();
    await this.getOrderItems();
    await this.$store.dispatch("drivers/getAreas");
  },
  computed: {
    list() {
      const list = [...this.$store.state.driverInformation.list];
      if (this.selectedArea === 0) {
        return list.sort(
          (a, b) => {
            let r = 0;
            console.log(a);
            if (a.farm.id < b.farm.id) { r = -1; } else if (a.farm.id > b.farm.id) { r = 1; }

            return r;
          },
        );
      }
      return list.filter(f => f.area_id === this.selectedArea);
    },
    driverType() {
      return this.$store.state.user.driver && this.$store.state.user.driver.driver_type;
    },
    isShippingDriver() {
      return this.driverType === "shipping";
    }
  },
  methods: {
    initializeDeliveryDate() {
      const deliveryDay = [1, 3, 5];
      let criteriaDate = new Date();
      if (!deliveryDay.includes(criteriaDate.getDay())) {
        criteriaDate = this.addDate(criteriaDate, 1);
      }
      while (this.deliveryDates.length < 3) {
        this.deliveryDates.push(this.formatDate(criteriaDate));
        criteriaDate = this.createCriteriaDate(criteriaDate);
      }
      this.selectedDate = this.deliveryDates[0];
    },
    getOrderItems() {
      this.$store.dispatch("driverInformation/getOrderItems", {
        dateFrom: this.selectedDate,
        dateTo: this.selectedDate
      });
    },
    addDate(date, addDay) {
      return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + addDay
      );
    },
    createCriteriaDate(date) {
      if (date.getDay() === 5) {
        return this.addDate(date, 3);
      }
      return this.addDate(date, 2);
    },
    formatDate(d) {
      return formatDate(d, "yyyy-mm-dd");
    }
  },
};
</script>

<style scoped>
/* A4縦用のベース設定 */
@page {
    size: A4 portrait; /* 横の場合はlandscape */
    margin: 0mm;
}
/* 各要素の余白リセット */
* {
    margin: 0mm;
    padding: 0mm;
}
/* 印刷時の調子を整える */
body {
    width: 210mm; /* 用紙の横幅を改めて指定 Chrome用 */
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    line-height: 1.5em;
    background: #eee;
}

/* 印刷1ページ用のコンテンツはここで定義 */
.page {
    width: 210mm; /* 用紙の横幅を改めて指定 */
    page-break-after: always;

    box-sizing: border-box;
    padding: 13.6mm 6.46mm; /*用紙の余白 */
}

.page:last-child {
  page-break-after: auto;
}

.label:nth-child(27n),
.label:nth-child(27n-1),
.label:nth-child(27n-2) {
  margin-top: 27.2mm;
}

@media screen {
  body {
      background: #eee;
  }
  .page {
      background: white; /* 背景を白く */
      margin: 5mm;
  }
  .page:last-child {
    page-break-after: auto;
  }
}
</style>
